"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathfindingSystem = void 0;
const Constants_1 = require("../../../Shared/Constants");
const gotti_1 = require("gotti");
const utils_1 = require("../../lib/Gottimation/utils");
class PathfindingSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.PATHFINDING);
        this.isInitialized = false;
        this.pathfindingPlugin = {
            name: 'pathfinding',
            type: 'collision',
            tagAs: [Constants_1.COLLIDER_TAGS.blocking],
            onAddedColliderWithTagA: (collider) => {
                switch (utils_1.resolveColliderType(collider.shapeData)) {
                    case "polygon":
                        this.globals.pathfinder.toggleBlockingPolygon(collider.shapeData, true);
                        break;
                    case "rect":
                        this.globals.pathfinder.toggleBlockingRect(collider.shapeData, true);
                        break;
                }
            },
        };
    }
    onEntityAddedComponent(entity, component) {
    }
    onInit() {
        this.globals.tileWorld.use(this.pathfindingPlugin);
    }
    onClear() {
    }
    onLocalMessage(message) {
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    update(delta) {
    }
}
exports.PathfindingSystem = PathfindingSystem;
//# sourceMappingURL=module.js.map